import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

const GPASection = ({ data, gpa }) => {
  const { id } = useParams();
  const idGPA = parseInt(id);
  const [itemTitle, setItemTitle] = useState({});
  const [gpaGrouping, setGpaGrouping] = useState({});

  useEffect(() => {
    if (data && gpa) {
      setItemTitle(data[0]);
      setGpaGrouping(gpa[1]);
    }
  }, [data, gpa]);

  console.log(gpa);

  return (
    <>
      {gpa &&
        gpaGrouping &&
        gpa
          .filter((gpa) => gpa?.t1key110 === idGPA)
          .map((filteredData) => (
            <div>
              {gpaGrouping["t1item120"] !== "null" && (
                <p style={{ fontSize: "20px" }}>
                  <strong>
                    {gpa[0]?.t1item120
                      ? `${gpa[0]?.t1item120}: ${filteredData?.t1item120}`
                      : ""}
                  </strong>
                </p>
              )}
              {gpaGrouping["t1item130"] !== "null" && (
                <p style={{ fontSize: "20px" }}>
                  <strong>
                    {gpa[0]?.t1item130
                      ? `${gpa[0]?.t1item130}: ${filteredData?.t1item130}`
                      : ""}
                  </strong>
                </p>
              )}
              {gpaGrouping["t1item140"] !== "null" && (
                <p style={{ fontSize: "20px" }}>
                  <strong>
                  <p>
                    {/* {gpa[0].t1item140}: {filteredData?.t1item140} */}
                    {gpa[0]?.t1item140
                      ? `${gpa[0]?.t1item140}: ${filteredData?.t1item140}`
                      : ""}
                  </p>
                  </strong>
                </p>
              )}
              {gpaGrouping["t1item150"] !== "null" && (
                <p style={{ fontSize: "20px" }}>
                  <strong>
                    {gpa[0]?.t1item150
                      ? `${gpa[0]?.t1item150}: ${filteredData?.t1item150}`
                      : ""}
                  </strong>
                </p>
              )}
              {gpaGrouping["t1item160"] !== "null" && (
                <p style={{ fontSize: "20px" }}>
                  <strong>
                    {gpa[0]?.t1item160
                      ? `${gpa[0]?.t1item160}: ${filteredData?.t1item160}`
                      : ""}
                  </strong>
                </p>
              )}
              {gpaGrouping["t1item170"] !== "null" && (
                <p style={{ fontSize: "20px" }}>
                  <strong>
                    {gpa[0]?.t1item170
                      ? `${gpa[0]?.t1item170}: ${filteredData?.t1item170}`
                      : ""}
                  </strong>
                </p>
              )}
              {gpaGrouping["t1item180"] !== "null" && (
                <p style={{ fontSize: "20px" }}>
                  <strong>
                    {gpa[0]?.t1item180
                      ? `${gpa[0]?.t1item180}: ${filteredData?.t1item180}`
                      : ""}
                  </strong>
                </p>
              )}
              {gpaGrouping["t1item190"] !== "null" && (
                <p style={{ fontSize: "20px" }}>
                  <strong>
                    {gpa[0]?.t1item190
                      ? `${gpa[0]?.t1item190}: ${filteredData?.t1item190}`
                      : ""}
                  </strong>
                </p>
              )}
              {gpaGrouping["t1item200"] !== "null" && (
                <p style={{ fontSize: "20px" }}>
                  <strong>
                    {gpa[0]?.t1item200
                      ? `${gpa[0]?.t1item200}: ${filteredData?.t1item200}`
                      : ""}
                  </strong>
                </p>
              )}
              {gpaGrouping["t1item210"] !== "null" && (
                <p style={{ fontSize: "20px" }}>
                  <strong>
                    {gpa[0]?.t1item210
                      ? `${gpa[0]?.t1item210}: ${filteredData?.t1item210}`
                      : ""}
                  </strong>
                </p>
              )}
              {gpaGrouping["t1item220"] !== "null" && (
                <p style={{ fontSize: "20px" }}>
                  <strong>
                    {gpa[0]?.t1item220
                      ? `${gpa[0]?.t1item220}: ${filteredData?.t1item220}`
                      : ""}
                  </strong>
                </p>
              )}
              {gpaGrouping["t1item230"] !== "null" && (
                <p style={{ fontSize: "20px" }}>
                  <strong>
                    {gpa[0]?.t1item230
                      ? `${gpa[0]?.t1item230}: ${filteredData?.t1item230}`
                      : ""}
                  </strong>
                </p>
              )}
              {gpaGrouping["t1item240"] !== "null" && (
                <p style={{ fontSize: "20px" }}>
                  <strong>
                    {gpa[0]?.t1item240
                      ? `${gpa[0]?.t1item240}: ${filteredData?.t1item240}`
                      : ""}
                  </strong>
                </p>
              )}
              {gpaGrouping["t1item250"] !== "null" && (
                <p style={{ fontSize: "20px" }}>
                  <strong>
                    {gpa[0]?.t1item250
                      ? `${gpa[0]?.t1item250}: ${filteredData?.t1item250}`
                      : ""}
                  </strong>
                </p>
              )}
            </div>
          ))}
    </>
  );
};
export default GPASection;

// {data &&
//   studentGrouping &&
//   data
//     .filter((data) => data.t1key110)
//     .map((filtereData) => <div></div>)}
